<button
  class="btn btn-link"
  (click)="onSave()"
  tabindex="0"
  type="button"
  [disabled]="disabled$ | async"
>
  <i class="fe fe-save text-success"></i>
</button>
